import './App.css';
import './normal.css'
import { useState, useEffect ,useRef } from 'react';
import ChatMessage from './components/ChatMessage';


function App() {

  // Type text into an element
  const messageRef = useRef(null);

  // Call the engines API to get the list of models
  useEffect(() => {
    getEngines();
  }, [])

  // Initialize the state
  const [lightMode, setLightMode] = useState(false);
  const [input, setInput] = useState('')
  const [models, setModels] = useState([])
  const [currentModel, setCurrentModel] = useState("text-davinci-003")
  const [context, setContext] = useState("Context:speak spanish")

// Set the initial chat log
  const [chatLog, setChatLog] = useState([
    { user: "gpt", message: "Como puedo ayudarte ?" },
  ])

  
  // Clear the chat log
  function clearChat() {
    setChatLog([])
  }

  // Get the list of models from the API
  const getEngines = async () => {
    const response = await fetch('https://proxel.onrender.com/models')
    const data = await response.json()
    setModels(data.models)
  }

  const toggleLightMode = () => {
    setLightMode(!lightMode);
  };

  // Handle the form submit
  async function handleSubmit(e) {
    e.preventDefault();

    // Add the user's message to the chat log
    let chatLogNew = [...chatLog, { user: "me", message: `${input}` }]
    setInput('')
    setChatLog(chatLogNew)
  
    //Convert the chat log to a string and send it to the API
    const messages = chatLogNew.map((message) => message.message).join('\n')

    // Send the message to the API
    const response = await fetch('https://proxel.onrender.com', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        message: messages,
        currentModel,
      })
    })
    // Get the response from the API and add it to the chat log
    const data = await response.json()
    setChatLog([...chatLogNew, { user: "gpt", message: `${data.message}` }])
  }

  

  return (
    <div className={`App ${lightMode ? "light-mode" : ""}`}>
    <aside className={`sidemenu ${lightMode ? "light-mode" : ""}`}>
        <div className="models">
          <select
            className='model-select'
            onChange={(e) => setCurrentModel(e.target.value)}><option defaultValue >Select a model</option>
            {models.map((model, index) => (
              <option key={model.id} value={model.id}>{model.id}</option>
            ))}
          </select>
        </div>
        <div className="side-menu-buttons">
        <div className='side-menu-button' onClick={clearChat}>
          <span>X</span>
          Clear Chat
        </div>
        <button className='side-menu-light' onClick={toggleLightMode}>Light/Dark</button>
        </div>
      </aside>
      <section className={`chatbox ${lightMode ? "light-mode" : ""}`}>
        <div className="chat-log">
          {chatLog.map((message, index) => (
            <ChatMessage key={index} message={message} />))}
        </div>
        <div className="chat-input-holder">
          <form onSubmit={handleSubmit}>
            <input
              rows="1"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              className="chat-input-textarea"></input>
          </form>
        </div>
      </section>
      
    </div>
  );
}




export default App;
